import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basis_einstellungen = _resolveComponent("basis-einstellungen")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_service_einstellungen = _resolveComponent("service-einstellungen")!
  const _component_speicher_diagramm = _resolveComponent("speicher-diagramm")!
  const _component_EditServiceDialog = _resolveComponent("EditServiceDialog")!
  const _component_FunktionEinstellungen = _resolveComponent("FunktionEinstellungen")!
  const _component_benutzer_liste = _resolveComponent("benutzer-liste")!
  const _component_teilnehmer_zugriff_liste = _resolveComponent("teilnehmer-zugriff-liste")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { sm: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_basis_einstellungen, {
                    "kunden-daten": _ctx.kundenData,
                    onSuccess: _ctx.getTeilnehmer
                  }, null, 8, ["kunden-daten", "onSuccess"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.kundenData.teilnehmerStatus)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                sm: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_service_einstellungen, {
                        "teilnehmer-service": _ctx.serviceData,
                        verrechnung: _ctx.verrechnungData
                      }, null, 8, ["teilnehmer-service", "verrechnung"]),
                      (_ctx.speicherData)
                        ? (_openBlock(), _createBlock(_component_speicher_diagramm, {
                            key: 0,
                            "belegter-speicher": _ctx.speicherData,
                            "maximaler-speicher": _ctx.calculateMaxSpeicher()
                          }, null, 8, ["belegter-speicher", "maximaler-speicher"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_col, {
                        class: "pl-6 pt-0 pb-6",
                        sm: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_EditServiceDialog, {
                            "user-services": _ctx.serviceData,
                            "user-verrechnung": _ctx.verrechnungData
                          }, null, 8, ["user-services", "user-verrechnung"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.kundenData.teilnehmerStatus)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 1,
                sm: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_FunktionEinstellungen, { "teilnehmer-funktion-api-dto": _ctx.teilnehmerFunktionData }, null, 8, ["teilnehmer-funktion-api-dto"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, { sm: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_benutzer_liste, { "benutzer-list": _ctx.benutzerData }, null, 8, ["benutzer-list"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { sm: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_teilnehmer_zugriff_liste, { "teilnehmer-zugriff-list": _ctx.teilnehmerZugriffe }, null, 8, ["teilnehmer-zugriff-list"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}